import * as SearchlightActions from 'a/actions/searchlightActions';

export const reportLoadSkillScan = (gameId, data, dispatch) => {
  dispatch(SearchlightActions.reportLoadGame(gameId, data));
  dispatch(SearchlightActions.reportRoundStart(gameId, { ...data, level: 1 }));
};

export const reportAggregateScore = (gameId, data, dispatch) =>
  dispatch(SearchlightActions.reportRoundComplete(gameId, { ...data, writtenByAPI: true }));
